import { getToken } from '@/utils/auth'

// 获取原图
export const getImgUrl = url => `${process.env.VUE_APP_BASE_API}/common/getFile?filePath=${encodeURIComponent(url)}&token=${encodeURIComponent(getToken())}`

// 获取缩略图
export const getCompressImage = url => `${process.env.VUE_APP_BASE_API}/common/getCompressImage?filePath=${encodeURIComponent(url)}&token=${encodeURIComponent(getToken())}`

// 获取设备二维码
export const getQrCode = params =>
  `${process.env.VUE_APP_BASE_API}/device/deviceLookQrCode?deviceId=${params.deviceId}&height=${params.height}&width=${params.width}&token=${encodeURIComponent(getToken())}`

// 获取巡更二维码
export const getPlaceQrCode = params =>
  `${process.env.VUE_APP_BASE_API}/patrol/patrolPlaceLookQrCode?patrolPlaceId=${params.patrolPlaceId}&height=${params.height}&width=${params.width}&token=${encodeURIComponent(
    getToken()
  )}`

export const baseURL = `${process.env.VUE_APP_BASE_API}/`

export const hostName = process.env.VUE_APP_BASE_HOSTNAME

export const baseURLImg = process.env.VUE_APP_BASE_URL

export const baseURLWSS = process.env.VUE_APP_BASE_URL_WSS

export const isPrd = process.env.VUE_APP_BASE_ENV === 'production'
